<template>
  <div class="confirm-form">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-col :span="8">
        <el-form-item label="发票类型" prop="fFpType">
          <el-select-ex
            v-model="form.fFpType"
            url="BasicInformation/FpType/FpTypeEntry"
            label-field="fName"
            value-field="fName"
            style="width: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="单位名称" prop="fDw">
          <el-select-table2
            v-model="form.fDw"
            url="BusinessManage/Invoice/InvoiceEntry"
            label-field="fDw"
            search-key="name"
            :columns="[
              { prop: 'fDw', label: '单位名称' },
              { prop: 'fShNumber', label: '社会统一信用代码' },
            ]"
            panel-width="30%"
            @change="fDwChange"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="社会统一信用代码" prop="fShNumber">
          <el-input v-model="form.fShNumber" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="地址" prop="fAddress">
          <el-input v-model="form.fAddress" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="电话" prop="fPhone">
          <el-input v-model="form.fPhone" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="开户行名称" prop="fBankName">
          <el-input v-model="form.fBankName" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="印章" prop="fSealID">
          <el-select-ex
            v-model="form.fSealID"
            url="Seal/SealEntry"
            label-field="fName"
            value-field="fid"
            style="width: 100%"
            @change="sealChange"
          />
          <p>
            <img
              v-if="fSealUrl"
              :src="fSealUrl"
              style="width: 150px"
            >
          </p>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="发票邮寄地址" prop="fAddress_fp">
          <el-input v-model="form.fAddress_fp" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="开户行账号" prop="fBankNumber">
          <el-input v-model="form.fBankNumber" />
        </el-form-item>
      </el-col>
    </el-form>
  </div>

</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'

export default {
  components: {},
  data: function() {
    return {
      form: {},
      fSealUrl: null,
      rules: {
        fFpType: [{ required: true, message: '必填项', trigger: 'change' }],
        fDw: [{ required: true, message: '必填项', trigger: 'change' }],
        fShNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fAddress: [{ required: true, message: '必填项', trigger: 'change' }],
        fPhone: [{ required: true, message: '必填项', trigger: 'change' }],
        fBankName: [{ required: true, message: '必填项', trigger: 'change' }],
        fSealID: [{ required: true, message: '必填项', trigger: 'change' }],
        fAddress_fp: [{ required: true, message: '必填项', trigger: 'change' }],
        fBankNumber: [{ required: true, message: '必填项', trigger: 'change' }]
      },

      activeName: 'fourth'
    }
  },
  computed: {},
  mounted() {
    // console.log(this.form, 'form1')
  },
  methods: {
    fDwChange: function(item) {
      Object.assign(this.form, item)
    },

    sealChange: function(item) {
      this.fSealUrl = item.pictureUrl
    },

    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang='less'>
.confirm-form{
    height: 250px;
}
</style>
